<template>
  <div>
    <v-btn
      @click="selectFile"
      :title="title"
    >{{title}}</v-btn>
    <form>
      <input
        type="file"
        class="upload-button"
        ref="upload"
        :accept="accept"
        @change="uploadFile"
      >
    </form>
  </div>
</template>

<script>
export default {
  name: 'UploadFileButton',
  data() {
    return {}
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: '.csv'
    }
  },
  methods: {
    selectFile() {
      this.$refs.upload.click()
    },
    uploadFile(event) {
      const files = event.target.files
      const form = event.target.form
      if (files.length > 0) {
        this.$emit('upload', files[0])
      }
      form.reset()
    }
  }
}
</script>
<style scoped>
.upload-button {
  display: none;
}
</style>

